export const industryCategories = [
  'Advertisement & Marketing',
  'Automotive',
  'Cloud Operations',
  'Consumer Packed Goods',
  'Data Products',
  'DevOps',
  'Education & Research',
  'Energy',
  'Financial Services',
  'Games',
  'Government',
  'Healthcare & Life Sciences',
  'Industrial',
  'Infrastructure Software',
  'IoT',
  'Machine Learning',
  'Manufacturing',
  'Media & Entertainment',
  'Nonprofit',
  'Power & Utilities',
  'Professional Services',
  'Retail',
  'Semiconductor',
  'Sports',
  'Telecom',
  'Travel and Hospitality',
]

export const partnershipType = [
  {
    label: 'ISV',
    value: 'ISV',
  },
  {
    label: 'CP',
    value: 'CP',
  },
]

export const dimensionUnitType = [
  {
    label: 'Bandwidth (Gbps)',
    value: 'BANDWIDTH-GB',
  },
  {
    label: 'Bandwidth (Mbps)',
    value: 'BANDWIDTH-MB',
  },
  {
    label: 'Data (GB)',
    value: 'DATA-GB',
  },
  {
    label: 'Data (MB)',
    value: 'DATA-MB',
  },
  {
    label: 'Host (Hours)',
    value: 'HOSTS',
  },
  {
    label: 'Requests',
    value: 'REQUESTS',
  },
  {
    label: 'Users',
    value: 'USERS',
  },
  {
    label: 'Units (Hours)',
    value: 'UNITS',
  },
]

export const dataType = [
  {
    label: 'Number',
    value: 'integer',
  },
  {
    label: 'Text',
    value: 'string',
  },
  {
    label: 'Dropdown',
    value: 'enum',
    disabled: true,
  },
  {
    label: 'Multi select dropdown',
    value: 'multi_enum',
    disabled: true,
  },
  {
    label: 'True or False',
    value: 'bool',
    disabled: true,
  },
  {
    label: 'Date',
    value: 'date',
    disabled: true,
  },
  {
    label: 'Date & time',
    value: 'datetime',
    disabled: true,
  },
  {
    label: 'Short text field',
    value: 'textarea',
    disabled: true,
  },
]

export const requiredField = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
]

export const validationType = [
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Phone',
    value: 'phone',
  },
  {
    label: 'URL',
    value: 'url',
  },
]

export const productCategoryData = [
  { label: 'Content Creation', group: 'AI Agents & Tools' },
  { label: 'Customer Experience Personalization', group: 'AI Agents & Tools' },
  { label: 'Customer Support', group: 'AI Agents & Tools' },
  { label: 'Data Analysis', group: 'AI Agents & Tools' },
  { label: 'Finance & Accounting', group: 'AI Agents & Tools' },
  { label: 'IT Support', group: 'AI Agents & Tools' },
  { label: 'Legal & Compliance', group: 'AI Agents & Tools' },
  { label: 'Observability', group: 'AI Agents & Tools' },
  { label: 'Procurement & Supply Chain', group: 'AI Agents & Tools' },
  { label: 'Quality Assurance', group: 'AI Agents & Tools' },
  { label: 'Research', group: 'AI Agents & Tools' },
  { label: 'Sales & Marketing', group: 'AI Agents & Tools' },
  { label: 'Scheduling & Coordination', group: 'AI Agents & Tools' },
  { label: 'Software Development', group: 'AI Agents & Tools' },
  { label: 'Backup & Recovery', group: 'Infrastructure Software' },
  { label: 'Data Analytics', group: 'Infrastructure Software' },
  { label: 'Data Integration', group: 'Infrastructure Software' },
  { label: 'Data Preparation', group: 'Infrastructure Software' },
  { label: 'ELT/ETL', group: 'Infrastructure Software' },
  { label: 'Streaming solutions', group: 'Infrastructure Software' },
  {
    label: 'Databases & Analytics Platforms',
    group: 'Infrastructure Software',
  },
  { label: 'Databases', group: 'Infrastructure Software' },
  { label: 'Data Warehouses', group: 'Infrastructure Software' },
  { label: 'Analytic Platforms', group: 'Infrastructure Software' },
  { label: 'Data Governance', group: 'Infrastructure Software' },
  { label: 'Data Catalogs', group: 'Infrastructure Software' },
  { label: 'Master Data Management', group: 'Infrastructure Software' },
  { label: 'Masking/Tokenization', group: 'Infrastructure Software' },
  {
    label: 'Business Intelligence & Advanced Analytics',
    group: 'Infrastructure Software',
  },
  { label: 'High Performance Computing', group: 'Infrastructure Software' },
  { label: 'Migration', group: 'Infrastructure Software' },
  { label: 'Network Infrastructure', group: 'Infrastructure Software' },
  { label: 'Operating Systems', group: 'Infrastructure Software' },
  { label: 'Security', group: 'Infrastructure Software' },
  { label: 'Storage', group: 'Infrastructure Software' },
  { label: 'Agile Lifecycle Management', group: 'DevOps' },
  { label: 'Application Development', group: 'DevOps' },
  { label: 'Application Servers', group: 'DevOps' },
  { label: 'Application Stacks', group: 'DevOps' },
  { label: 'Continuous Integration and Continuous Delivery', group: 'DevOps' },
  { label: 'Infrastructure as Code', group: 'DevOps' },
  { label: 'Issue & Bug Tracking', group: 'DevOps' },
  { label: 'Monitoring', group: 'DevOps' },
  { label: 'Log Analysis', group: 'DevOps' },
  { label: 'Source Control', group: 'DevOps' },
  { label: 'Testing', group: 'DevOps' },
  { label: 'Blockchain', group: 'Business Applications' },
  { label: 'Collaboration & Productivity', group: 'Business Applications' },
  { label: 'Contact Center', group: 'Business Applications' },
  { label: 'Content Management', group: 'Business Applications' },
  { label: 'CRM', group: 'Business Applications' },
  { label: 'eCommerce', group: 'Business Applications' },
  { label: 'eLearning', group: 'Business Applications' },
  { label: 'Human Resources', group: 'Business Applications' },
  { label: 'IT Business Management', group: 'Business Applications' },
  { label: 'Project Management', group: 'Business Applications' },
  { label: 'Human Review Services', group: 'Machine Learning' },
  { label: 'ML Solutions', group: 'Machine Learning' },
  { label: 'Data Labeling Services', group: 'Machine Learning' },
  {
    label: 'Amazon SageMaker Ground Truth Services',
    group: 'Machine Learning',
  },
  { label: 'Computer Vision', group: 'Machine Learning' },
  { label: 'Natural Language Processing', group: 'Machine Learning' },
  { label: 'Speech Recognition', group: 'Machine Learning' },
  { label: 'Text', group: 'Machine Learning' },
  { label: 'Classification-Text', group: 'Machine Learning' },
  { label: 'Clustering-Text', group: 'Machine Learning' },
  { label: 'Edit/Processing-Text', group: 'Machine Learning' },
  { label: 'Embeddings', group: 'Machine Learning' },
  { label: 'Generation-Text', group: 'Machine Learning' },
  { label: 'Generative AI', group: 'Machine Learning' },
  { label: 'Grammar/Parsing-Text', group: 'Machine Learning' },
  { label: 'Identification-Text', group: 'Machine Learning' },
  { label: 'Names Entity Recognition - NER', group: 'Machine Learning' },
  { label: 'Sentiment Analysis', group: 'Machine Learning' },
  { label: 'Summarization-Text', group: 'Machine Learning' },
  { label: 'Text to Speech', group: 'Machine Learning' },
  { label: 'Translation', group: 'Machine Learning' },
  { label: 'Image', group: 'Machine Learning' },
  { label: '3D', group: 'Machine Learning' },
  { label: 'Captioning', group: 'Machine Learning' },
  { label: 'Classification-Image', group: 'Machine Learning' },
  { label: 'Edit/Processing-Image', group: 'Machine Learning' },
  { label: 'Embedding/Feature Extraction', group: 'Machine Learning' },
  { label: 'Generation-Image', group: 'Machine Learning' },
  { label: 'Grammar/Parsing-Image', group: 'Machine Learning' },
  { label: 'Handwriting Recognition', group: 'Machine Learning' },
  { label: 'Human/Faces', group: 'Machine Learning' },
  { label: 'Object Detection-Image', group: 'Machine Learning' },
  { label: 'Segmentation/Pixel Labeling', group: 'Machine Learning' },
  { label: 'Text/OCR', group: 'Machine Learning' },
  { label: 'Video', group: 'Machine Learning' },
  { label: 'Classification-Video', group: 'Machine Learning' },
  { label: 'Object Detection-Video', group: 'Machine Learning' },
  { label: 'Edit/Processing-Video', group: 'Machine Learning' },
  { label: 'Anomaly Detection-Video', group: 'Machine Learning' },
  { label: 'Speaker Identification-Video', group: 'Machine Learning' },
  { label: 'Motion', group: 'Machine Learning' },
  { label: 'Reidentification', group: 'Machine Learning' },
  { label: 'Summarization-Video', group: 'Machine Learning' },
  { label: 'Text/Captioning', group: 'Machine Learning' },
  { label: 'Tracking', group: 'Machine Learning' },
  { label: 'Audio', group: 'Machine Learning' },
  { label: 'Speaker Identification-Audio', group: 'Machine Learning' },
  { label: 'Speech to Text', group: 'Machine Learning' },
  { label: 'Classification-Audio', group: 'Machine Learning' },
  { label: 'Song Identification', group: 'Machine Learning' },
  { label: 'Segmentation', group: 'Machine Learning' },
  { label: 'Structured', group: 'Machine Learning' },
  { label: 'Anomaly Detection-Structured', group: 'Machine Learning' },
  { label: 'Classification-Structured', group: 'Machine Learning' },
  { label: 'Clustering-Structured', group: 'Machine Learning' },
  { label: 'Dimensionality Reduction', group: 'Machine Learning' },
  { label: 'Factorization Models', group: 'Machine Learning' },
  { label: 'Feature Engineering', group: 'Machine Learning' },
  { label: 'Ranking', group: 'Machine Learning' },
  { label: 'Regression', group: 'Machine Learning' },
  { label: 'Time-series Forecasting', group: 'Machine Learning' },
  { label: 'Analytics', group: 'IoT' },
  { label: 'Applications', group: 'IoT' },
  { label: 'Device Connectivity', group: 'IoT' },
  { label: 'Device Management', group: 'IoT' },
  { label: 'Device Security', group: 'IoT' },
  { label: 'Industrial IoT', group: 'IoT' },
  { label: 'Smart Home & City', group: 'IoT' },
  { label: 'Education & Research', group: 'Industries' },
  { label: 'Financial Services', group: 'Industries' },
  { label: 'Healthcare & Life Sciences', group: 'Industries' },
  { label: 'Media & Entertainment', group: 'Industries' },
  { label: 'Industrial', group: 'Industries' },
  { label: 'Energy', group: 'Industries' },
  { label: 'Automotive', group: 'Industries' },
  { label: 'Assessments', group: 'Professional Services' },
  { label: 'Implementation', group: 'Professional Services' },
  { label: 'Managed Services', group: 'Professional Services' },
  { label: 'Premium Support', group: 'Professional Services' },
  { label: 'Training', group: 'Professional Services' },
  { label: 'Cloud Governance', group: 'Cloud Operations' },
  { label: 'Centralized Identity Management', group: 'Cloud Operations' },
  { label: 'Data Security and Governance', group: 'Cloud Operations' },
  { label: 'Log Management', group: 'Cloud Operations' },
  { label: 'Tagging Solutions', group: 'Cloud Operations' },
  { label: 'Cloud Financial Management', group: 'Cloud Operations' },
  { label: 'Container Cost Optimization', group: 'Cloud Operations' },
  { label: 'Cost Allocation and Accountability', group: 'Cloud Operations' },
  { label: 'Hybrid Cost Visibility', group: 'Cloud Operations' },
  { label: 'Optimize with Spot Instances', group: 'Cloud Operations' },
  { label: 'Planning and Forecasting', group: 'Cloud Operations' },
  { label: 'Purchase Option Optimization', group: 'Cloud Operations' },
  { label: 'Resource Cost Optimization', group: 'Cloud Operations' },
  { label: 'Monitoring and Observability', group: 'Cloud Operations' },
  {
    label: 'Application Performance and UX Monitoring',
    group: 'Cloud Operations',
  },
  { label: 'Container Workloads', group: 'Cloud Operations' },
  { label: 'Hybrid Monitoring', group: 'Cloud Operations' },
  { label: 'N-tier Workloads', group: 'Cloud Operations' },
  { label: 'Security Observability', group: 'Cloud Operations' },
  { label: 'Serverless Workloads', group: 'Cloud Operations' },
  { label: 'Compliance and Auditing', group: 'Cloud Operations' },
  { label: 'Audit Support', group: 'Cloud Operations' },
  {
    label: 'Automated Auditing Controls Deployment',
    group: 'Cloud Operations',
  },
  { label: 'Centralized Risk Management', group: 'Cloud Operations' },
  { label: 'Cleanroom and Forensics', group: 'Cloud Operations' },
  { label: 'Data Anonymization', group: 'Cloud Operations' },
  { label: 'Operations Management', group: 'Cloud Operations' },
  { label: 'AIOps', group: 'Cloud Operations' },
  { label: 'Centralized Change Management', group: 'Cloud Operations' },
  { label: 'Discovery and Configuration Tracking', group: 'Cloud Operations' },
  { label: 'Hybrid Compute Remote Access', group: 'Cloud Operations' },
  { label: 'ITSM Solutions', group: 'Cloud Operations' },
  { label: 'PPD Controls Management', group: 'Cloud Operations' },
  { label: 'Vulnerability and Patch Management', group: 'Cloud Operations' },
  { label: 'Financial Services Data', group: 'Data' },
  { label: 'Retail, Location & Marketing Data', group: 'Data' },
  { label: 'Public Sector Data', group: 'Data' },
  { label: 'Healthcare & Life Sciences Data', group: 'Data' },
  { label: 'Resources Data', group: 'Data' },
  { label: 'Media & Entertainment Data', group: 'Data' },
  { label: 'Telecommunications Data', group: 'Data' },
  { label: 'Environmental Data', group: 'Data' },
  { label: 'Automotive Data', group: 'Data' },
  { label: 'Manufacturing Data', group: 'Data' },
  { label: 'Gaming Data', group: 'Data' },
]
